// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/system';
// MUI icons
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

// load navigation contents from JSON file
import headerNavigationItemsProduction from '@config/data/headerNavigationItems.json';
import headerNavigationItemsStaging from '@config/data/headerNavigationItems.staging.json';
import headerNavigationItemsDevelopment from '@config/data/headerNavigationItems.development.json';

// Section for import custom components --------------------------------------------------------------------------------
import CommonUtility from '@utils/Common';
import { AppConfigContext } from '@providers/AppConfigProvider';

const StyledAccordionSummary = styled(AccordionSummary)({
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 0,
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
  '& .MuiAccordionSummary-expandIcon': {
    order: -1,
  },
  '& .Mui-expanded': {
    margin: '0 !important',
  },
});

export default function MenuContent(): React.JSX.Element {
  const { appEnv } = useContext(AppConfigContext);

  const headerNavigationItems = CommonUtility.getEnvBasedValue(
    {
      production: headerNavigationItemsProduction,
      staging: headerNavigationItemsStaging,
      development: headerNavigationItemsDevelopment,
    },
    appEnv,
  );

  return (
    <Box>
      {headerNavigationItems.map((item, index) =>
        item.children && item.children.length > 0 ? (
          <Accordion
            sx={{
              backgroundColor: '#191919',
              color: 'white',
              borderBottom: '1px solid white',
              borderTop: index === 0 ? '1px solid white' : 'none',
              borderRadius: '0 !important',
              '&.Mui-expanded': {
                margin: 0,
              },
            }}
          >
            <StyledAccordionSummary
              className="min-h-fit"
              expandIcon={<KeyboardArrowDownRoundedIcon style={{ color: 'white' }} />}
            >
              <Typography className="py-4 text-base font-bold rf-hover-text" style={{ flexGrow: 1 }}>
                <a href={item.href} rel="noopener noreferrer" className="hover:no-underline text-white text-base">
                  {item.label}
                </a>
              </Typography>
            </StyledAccordionSummary>
            <AccordionDetails className="flex flex-col pl-4 py-0">
              {item.children.map((child) => (
                <div key={child.label} className="pb-4 last:pb-5 text-sm rf-hover-text">
                  <Typography>
                    <a
                      href={child.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:no-underline text-white text-sm"
                    >
                      {child.label}
                    </a>
                  </Typography>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        ) : (
          <Box
            style={{
              backgroundColor: '#191919',
              color: 'white',
              borderBottom: '1px solid white',
              borderTop: index === 0 ? '1px solid white' : 'none',
            }}
          >
            <Typography className="py-4 text-base font-bold rf-hover-text" style={{ flexGrow: 1 }}>
              <a href={item.href} rel="noopener noreferrer" className="hover:no-underline text-white">
                {item.label}
              </a>
            </Typography>
          </Box>
        ),
      )}
    </Box>
  );
}
